import React from 'react'
import ModalFactWrapper from '../ModalFactWrapper'
import ScrollBar from 'react-scrollbar'
import classNames from 'classnames'

import './style.scss'

class ModalFactContent extends React.Component {
  render() {
    let quiz = this.props.data.quiz

    return (
      <div className={classNames('modal-content', {'filled-background' : this.props.data.background, 'quiz-background' : quiz && quiz.hasOwnProperty('questions')})}>
        <div className="control-wrapper">
          <span
            className={classNames('icon-close', {'white' : this.props.data.background && !this.props.data.darkColorCloseIcon})}
            onClick={() => this.props.closeModal}
          />
        </div>
        {
          this.props.windowWidth <= 980 ?
            <ScrollBar>
              <ModalFactWrapper
                {...this.props}
                quiz={quiz}
              />
            </ScrollBar>
            :
            <ModalFactWrapper
              {...this.props}
              quiz={quiz}
            />
        }
      </div>
    );
  }
}

export default ModalFactContent
